import { FormControl } from "@angular/forms";

export function emailValidator(control: FormControl) {
    const emailPattern = "[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,3}";
    const regex = new RegExp(emailPattern)
    const formControlValue = control?.value?.length ? control.value.trim() : control.value;
    if (formControlValue?.length) {
        return regex.test(formControlValue) ? null : { 'valid': false };
    } else {
        return null;
    }
}
